import contactInquiry from './contactInquiry.json';

const frContactInquiry = {
    ...contactInquiry,
}

export default frContactInquiry;
